<script setup>
import { useFinanceStore } from '~/store/finance'

defineProps({
  list: {
    type: Array,
    default: () => [],
  },
})
const localePath = useLocalePath()
const finance = useFinanceStore()
finance.getAssets()
</script>

<template>
  <div class="flex flex-col gap-4  pb-6 px-4 w-[432px]">
    <div v-for="i, index in list" :key="index" class="flex rounded-lg">
      <component :is="i.icon" class="w-4 h-4 me-2" />
      <span class="flex flex-col">
        <span class="text-xs text-textPrimary">{{ i.label }}</span>
        <span class="text-2xl font-bold">{{ fix(finance.getBanlanceByType({ type: i.key, unit: 'usdt' }), 2) }} USDT</span>
      </span>
    </div>
    <div class="flex gap-2">
      <NuxtLink :to="localePath('/assets/deposit')" class="flex-1">
        <CommonXButton class="w-full">
          {{ $t('充值') }}
        </CommonXButton>
      </NuxtLink>
      <NuxtLink :to="localePath('/assets/withdraw')" class="flex-1">
        <CommonXButton type="tertiary" class="w-full">
          {{ $t('提现') }}
        </CommonXButton>
      </NuxtLink>
    </div>
  </div>
</template>
